import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Plus } from '../../../components/Icon';
import { Card } from '../../../components/Card';
import { Modal, ModalControls } from '../../../components/Modal';
import { selectWorks } from '../../Api/selectors';
import { UserDataCard } from '../../Users/components/CardData';
import { UserSelection } from '../../Users/components/UserSelection';
import { List, Row, Cell } from '../../../components/List';
import { addUserToCompany, deleteUserFromCompany } from '../actions';
import { REQUEST_COMPANY_ADD_USER, REQUEST_COMPANY_DELETE_USER_FROM_COMPANY } from '../constants';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import { UserModal } from '../../Users/components/AddUserModal';
import { CREATE_USER, REQUEST_USER } from '../../Users/constants';
import { WebsiteLoginPermissionsCard } from '../../Users/components/CardWebsiteLoginPermissions';
import { parseUser } from '../../Users/helpers';
import LoadingCard from '../../../containers/App/Components/LoadingCard/LoadingCard';

const STATE = {
  createUser: false,
  deleteUser: false,
  addUser: false,
};

const Container = styled.div`
  background-color: #fff;
  font-size: 14px;
  margin: 6px 0;
  padding: 0;
  width: 100%;

  .title-block {
    padding: 0 12px;

    .title {
      text-transform: uppercase;
      font-size: 14px;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CompanyUsersComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get company() {
    return this.props.company;
  }

  render() {
    const company = this.company;
    if (!company) return null;
    return (
      <Container>
        <Card className="company-info-card info">
          <HBox vCenter className="title-block">
            <h2 style={{ marginTop: '10px' }} className="title">
              {this.lbl('company.details.contacts')}
            </h2>
          </HBox>
          <HBox vCenter className="title-block">
            <Button small onClick={this.setStateFn({ addUser: true })}>
              <Plus />
              {this.lbl('add')}
            </Button>
            {this.props.companyDetails && (
              <Button small onClick={this.setStateFn({ createUser: true })}>
                <Plus />
                {this.lbl('company.details.contacts.create_new')}
              </Button>
            )}
          </HBox>

          {this.props.workEdit ? (
            <LoadingCard />
          ) : (
            <List className="users-list">{company.users?.map(this.renderUser.bind(this))}</List>
          )}
          {this.renderDeleteUser()}
          {this.renderAddUser()}
          {this.renderCreateUser()}
        </Card>
      </Container>
    );
  }

  renderUser(user) {
    if (this.props.companyDetails) {
      const parsedUser = parseUser(user);
      return <WebsiteLoginPermissionsCard key={user.id} user={parsedUser} companyDetails companyId={this.company.id} />;
    }

    return (
      <UserDataCard
        key={user.id}
        user={user}
        onClick={this.setStateFn({ deleteUser: user })}
        onRemove={this.setStateFn({ deleteUser: user })}
      />
    );
  }

  renderCreateUser() {
    if (!this.state.createUser) return null;
    return (
      <>
        <UserModal
          toggle={() => this.setState({ createUser: false })}
          addToCompany={userId => {
            this.props.addUser(userId, this.reset.bind(this));
          }}
        />
      </>
    );
  }

  renderAddUser() {
    if (!this.state.addUser) return null;
    return (
      <ModalComponent title={this.lbl('company.users.delete.confirm.title')} onClose={this.reset.bind(this)}>
        {this.state.deleteUser.email_address}
        {this.state.addUser.id ? (
          <List>
            <Row>
              <Cell>{'E-mail'}</Cell>
              <Cell>{'Name'}</Cell>
              <Cell>{'Surname'}</Cell>
            </Row>

            <Row>
              <Cell>{this.state.addUser.email_address}</Cell>
              <Cell>{this.state.addUser.name}</Cell>
              <Cell>{this.state.addUser.surname}</Cell>
            </Row>
          </List>
        ) : (
          <UserSelection onSelect={user => this.setState({ addUser: user })} />
        )}
        <div className="d-flex gap-2 mt-2">
          <ButtonComponent
            style="ButtonSoftEdit"
            disabled={!this.state.addUser.id}
            onClick={() => this.props.addUser(this.state.addUser.id, this.reset.bind(this))}
          >
            {this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderDeleteUser() {
    if (!this.state.deleteUser) return null;
    return (
      <ModalComponent title={this.lbl('company.users.delete.confirm.title')} onClose={this.reset.bind(this)}>
        {this.state.deleteUser.email_address}
        <div className="d-flex gap-2 mt-2">
          <ButtonComponent
            style="ButtonSoftEdit"
            onClick={() => this.props.deleteUser(this.state.deleteUser.id, this.reset.bind(this))}
          >
            {this.lbl('ok')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

CompanyUsersComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    works: selectWorks([REQUEST_COMPANY_DELETE_USER_FROM_COMPANY, REQUEST_COMPANY_ADD_USER, CREATE_USER]),
    workEdit: selectWorks([REQUEST_USER]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    deleteUser(userId, callback) {
      dispatch(deleteUserFromCompany(ownProps.company.id, userId, callback));
    },
    addUser(userId, callback) {
      dispatch(addUserToCompany(ownProps.company.id, userId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyUsers = compose(withConnect, withRouter)(CompanyUsersComp);
